module.exports = __webpack_public_path__ + "static/media/red-fox-2230731_640-min.e602a41b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/red-fox-2230731_640-min.jpg
// module id = 135
// module chunks = 0